// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_rentalProperties(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "ChapterDefaultNotificationSetting",
    "CustomPropertyNotificationPreference",
    "MatchesOnlyNotificationSetting"
  ]);
}

let fragmentConverter = {"__root":{"rentalProperties_CustomPropertyNotificationPreference_areaGroup":{"f":""},"rentalProperties_CustomPropertyNotificationPreference":{"f":""},"rentalProperties":{"u":"fragment_rentalProperties"},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_rentalProperties: unwrap_fragment_rentalProperties
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function propertyNotificationPreferenceMLSStatus_decode($$enum) {
  if ($$enum === "ANY" || $$enum === "NOT_ACTIVE_ON_MLS") {
    return $$enum;
  }
}

let propertyNotificationPreferenceMLSStatus_fromString = propertyNotificationPreferenceMLSStatus_decode;

let Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  propertyNotificationPreferenceMLSStatus_decode: propertyNotificationPreferenceMLSStatus_decode,
  propertyNotificationPreferenceMLSStatus_fromString: propertyNotificationPreferenceMLSStatus_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "kind": "RequiredField",
    "field": {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userHasInactiveCustomPreference",
      "storageKey": null
    },
    "action": "THROW"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsRentalProperties_notificationSetting",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsPreferenceEditDialog_settings"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "rentalProperties",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "ChapterDefaultNotificationSetting",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "MatchesOnlyNotificationSetting",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mlsStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "propertyTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "areaGroup",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NotificationSettingsComponents_group"
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NotificationSettingsPreferenceEditDialog_preference"
            }
          ],
          "type": "CustomPropertyNotificationPreference",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNotificationSettingsV5",
  "abstractKey": null
};
})());

let wrap_fragment_rentalProperties = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_rentalProperties = unwrap_fragment_rentalProperties;
exports.wrap_fragment_rentalProperties = wrap_fragment_rentalProperties;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
